import React, { useState, useEffect } from 'react';
import api from '../api';

const IconHistory = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const IconPrint = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
  </svg>
);

const IconCheckbox = ({ checked }) => checked ? (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M2 3a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1H3a1 1 0 01-1-1V3zm11.707 4.293a1 1 0 00-1.414-1.414L9 9.172 7.707 7.879a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
) : (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth={2} />
  </svg>
);

function formatarData(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${String(y).slice(2)}`;
}

export default function GuiaMontagemDiaria() {
  const [tamanhos, setTamanhos] = useState([]);
  const [tamanhosCongelados, setTamanhosCongelados] = useState([]);
  const [recheios, setRecheios] = useState([]);
  const [fichasMassa, setFichasMassa] = useState([]);
  const [menuFixo, setMenuFixo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const [data, setData] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
  });
  const [observacoes, setObservacoes] = useState('');
  const [itens, setItens] = useState([]);
  const [itensCongelados, setItensCongelados] = useState({});
  const [pedidosCongelados, setPedidosCongelados] = useState({});

  const [editandoId, setEditandoId] = useState(null); // id da montagem sendo editada
  const [resultado, setResultado] = useState(null);
  const [abas, setAbas] = useState('fichas');

  const [historicoAberto, setHistoricoAberto] = useState(false);
  const [historico, setHistorico] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = useState(false);

  const [montados, setMontados] = useState({});
  const [retiradoFreezer, setRetiradoFreezer] = useState(false);

  // Persiste estado "montado" e "retirado" no localStorage por montagem
  useEffect(() => {
    const id = resultado?.montagem_id;
    if (!id) return;
    localStorage.setItem(`montados_${id}`, JSON.stringify(montados));
  }, [montados, resultado?.montagem_id]);

  useEffect(() => {
    const id = resultado?.montagem_id;
    if (!id) return;
    localStorage.setItem(`retirado_${id}`, JSON.stringify(retiradoFreezer));
  }, [retiradoFreezer, resultado?.montagem_id]);
  const [modalReceita, setModalReceita] = useState(null); // { nome, nReceitas, ficha }
  const [modalLoading, setModalLoading] = useState(false);

  async function abrirModalReceita(nomeComponente, nReceitas) {
    const recheioBase = recheios.find(r => r.base_nome === nomeComponente);
    const recheioComp = recheios.find(r => r.complemento_nome === nomeComponente);
    const fichaId = recheioBase?.base_ficha_id || recheioComp?.complemento_ficha_id;
    if (!fichaId) return;
    setModalLoading(nomeComponente);
    try {
      const res = await api.get(`/fichas/api/fichas-tecnicas/${fichaId}`);
      if (res.data.success) setModalReceita({ nome: nomeComponente, nReceitas, ficha: res.data.ficha });
    } catch {}
    finally { setModalLoading(false); }
  }

  useEffect(() => { carregarDados(); }, []);

  async function carregarDados() {
    setLoading(true);
    try {
      const [resTam, resTamC, resRec, resFichas, resMenu] = await Promise.all([
        api.get('/guia/tamanhos?tipo=imediato'),
        api.get('/guia/tamanhos?tipo=congelado'),
        api.get('/guia/recheios'),
        api.get('/fichas/api/fichas-tecnicas'),
        api.get('/guia/menu-fixo'),
      ]);
      setTamanhos(resTam.data);
      setTamanhosCongelados(resTamC.data);
      setRecheios(resRec.data);
      setFichasMassa((resFichas.data?.fichas || []).filter(f => f.categoria === 'Massas de Bolo'));
      setMenuFixo(resMenu.data);
    } catch { setErro('Erro ao carregar dados'); }
    finally { setLoading(false); }
  }

  async function carregarHistorico() {
    setLoadingHistorico(true);
    try { const res = await api.get('/guia/montagens'); setHistorico(res.data || []); }
    catch { setHistorico([]); }
    finally { setLoadingHistorico(false); }
  }

  async function excluirMontagem(id) {
    if (!window.confirm('Excluir esta montagem?')) return;
    try {
      await api.delete(`/guia/montagens/${id}`);
      setHistorico(prev => prev.filter(h => h.id !== id));
      localStorage.removeItem(`montados_${id}`);
      localStorage.removeItem(`retirado_${id}`);
    } catch { setErro('Erro ao excluir montagem'); }
  }

  async function reabrirMontagem(id) {
    try {
      const res = await api.get(`/guia/montagens/${id}/calcular`);
      setResultado(res.data);
      const saved = localStorage.getItem(`montados_${id}`);
      setMontados(saved ? JSON.parse(saved) : {});
      const savedRetirado = localStorage.getItem(`retirado_${id}`);
      setRetiradoFreezer(savedRetirado ? JSON.parse(savedRetirado) : false);
      setAbas('fichas'); setHistoricoAberto(false);
    } catch { setErro('Erro ao carregar montagem'); }
  }

  // FIX: ao editar, separa congelados (que batem com menuFixo) de imediatos
  async function editarMontagem(id) {
    try {
      const res = await api.get(`/guia/montagens/${id}`);
      const m = res.data;
      setData(m.data);
      setObservacoes(m.observacoes || '');

      const novosCongelados = {};
      const novosPedidosCongelados = {};
      const novosImediatos = [];
      (m.itens || []).forEach(i => {
        const menuItem = menuFixo.find(mf =>
          mf.tamanho_id === i.tamanho_id &&
          mf.massa_ficha_id === i.massa_ficha_id &&
          mf.recheio_id === i.recheio_principal_id &&
          i.recheio_principal_id === i.recheio_secundario_id
        );
        if (menuItem) {
          // Acumula (cada unidade pode ser 1 registro ou um registro com qty>1 — soma sempre)
          novosCongelados[menuItem.id] = (novosCongelados[menuItem.id] || 0) + i.quantidade;
          if (!novosPedidosCongelados[menuItem.id]) novosPedidosCongelados[menuItem.id] = [];
          // Cada item do DB representa i.quantidade unidades com o mesmo pedido
          for (let u = 0; u < i.quantidade; u++) {
            novosPedidosCongelados[menuItem.id].push(u === 0 ? (i.pedido || '') : '');
          }
        } else {
          // Imediatos: expandir itens com qty>1 em múltiplos itens de qty=1 (padrão novo)
          for (let u = 0; u < i.quantidade; u++) {
            novosImediatos.push({
              id: Date.now() + Math.random(),
              tamanho_id: i.tamanho_id,
              massa_ficha_id: i.massa_ficha_id,
              recheio_principal_id: i.recheio_principal_id,
              recheio_secundario_id: i.recheio_secundario_id,
              recheio_unico: i.recheio_principal_id === i.recheio_secundario_id,
              quantidade: 1,
              pedido: u === 0 ? (i.pedido || '') : '',
            });
          }
        }
      });

      setItens(novosImediatos);
      setItensCongelados(novosCongelados);
      setPedidosCongelados(novosPedidosCongelados);
      setEditandoId(id);
      setResultado(null);
      setHistoricoAberto(false);
    } catch { setErro('Erro ao carregar montagem para edição'); }
  }

  // ── Itens imediatos ───────────────────────────────────────────────────────────
  function adicionarItem() {
    setItens(prev => [...prev, {
      id: Date.now(),
      tamanho_id: '',
      massa_ficha_id: '',
      recheio_principal_id: '',
      recheio_secundario_id: '',
      recheio_unico: false,
      quantidade: 1,
      pedido: '',
    }]);
  }

  function removerItem(id) { setItens(prev => prev.filter(i => i.id !== id)); }

  function atualizarItem(id, campo, valor) {
    setItens(prev => prev.map(i => {
      if (i.id !== id) return i;
      const u = { ...i, [campo]: valor };
      if (campo === 'recheio_unico' && valor) u.recheio_secundario_id = u.recheio_principal_id;
      if (campo === 'recheio_principal_id' && u.recheio_unico) u.recheio_secundario_id = valor;
      return u;
    }));
  }

  // ── Congelados ───────────────────────────────────────────────────────────────
  function setQtdCongelado(menuItemId, val) {
    const n = Math.max(0, parseInt(val) || 0);
    setItensCongelados(prev => ({ ...prev, [menuItemId]: n }));
    setPedidosCongelados(prev => {
      const arr = [...(prev[menuItemId] || [])];
      while (arr.length < n) arr.push('');
      return { ...prev, [menuItemId]: arr.slice(0, n) };
    });
  }
  function getQtdCongelado(id) { return itensCongelados[id] || 0; }

  function calcularCoberturaCongelados() {
    const porTamanho = {};
    menuFixo.forEach(m => {
      const qtd = getQtdCongelado(m.id);
      if (!qtd) return;
      const t = tamanhosCongelados.find(t => t.id === m.tamanho_id);
      if (!t) return;
      if (!porTamanho[t.id]) {
        porTamanho[t.id] = { nome: t.nome, cakeboard: t.cakeboard_tamanho || t.nome, qtd: 0, cobertura: 0, cinta: 0 };
      }
      porTamanho[t.id].qtd += qtd;
      porTamanho[t.id].cobertura += qtd * (t.cobertura_camadas || 0) * (t.cobertura_gramas || 0);
      porTamanho[t.id].cinta += qtd * (t.cinta_camadas || 0) * (t.cinta_gramas || 0);
    });
    return Object.values(porTamanho);
  }

  // Resumo dos congelados para a ficha (lista de bolos a retirar)
  function listaCongeladosParaRetirar() {
    const lista = [];
    menuFixo.forEach(m => {
      const qtd = getQtdCongelado(m.id);
      if (!qtd) return;
      const t = tamanhosCongelados.find(t => t.id === m.tamanho_id);
      if (!t) return;
      lista.push({ tamanho: t.nome, massa: m.massa_ficha_nome, recheio: m.recheio_nome, qtd });
    });
    return lista;
  }

  const totalCongelados = Object.values(itensCongelados).reduce((a, b) => a + b, 0);

  // ── Consolidado imediatos — tabela agrupada por tamanho ──────────────────────
  function calcularTabelaImediatos() {
    if (!resultado?.fichas_individuais) return [];
    const agrupado = {};
    resultado.fichas_individuais.forEach(ficha => {
      const t = tamanhos.find(t => t.nome === ficha.tamanho);
      const key = `${ficha.tamanho}||${ficha.massa || ''}`;
      if (!agrupado[key]) {
        agrupado[key] = {
          tamanho: ficha.tamanho,
          massa: ficha.massa || '—',
          quantidade: 0,
          cakeboard: t?.cakeboard_tamanho || '—',
          calda: ficha.calda?.total || 0,
          cinta: ficha.cinta?.total || 0,
          cobertura: ficha.cobertura?.total || 0,
        };
      }
      agrupado[key].quantidade += ficha.quantidade;
    });
    return Object.values(agrupado);
  }

  // ── Salvar ───────────────────────────────────────────────────────────────────
  async function salvarECalcular(e) {
    e.preventDefault();
    const totalItens = itens.length + Object.values(itensCongelados).filter(v => v > 0).length;
    if (totalItens === 0) { setErro('Adicione pelo menos um bolo.'); return; }

    setSalvando(true); setErro(''); setResultado(null); setMontados({}); setRetiradoFreezer(false);

    const coberturaCongelados = calcularCoberturaCongelados();
    const congeladosRetirar = listaCongeladosParaRetirar();

    const novosItens = itens.map(i => ({
      tamanho_id: Number(i.tamanho_id),
      massa_ficha_id: Number(i.massa_ficha_id),
      recheio_principal_id: Number(i.recheio_principal_id),
      recheio_secundario_id: Number(i.recheio_secundario_id),
      quantidade: Number(i.quantidade),
      pedido: i.pedido || null,
    }));

    // FIX: incluir congelados no payload (recheio único: principal === secundário)
    menuFixo.forEach(m => {
      const qtd = itensCongelados[m.id] || 0;
      if (!qtd) return;
      const pedArr = pedidosCongelados[m.id] || [];
      for (let i = 0; i < qtd; i++) {
        novosItens.push({
          tamanho_id: Number(m.tamanho_id),
          massa_ficha_id: Number(m.massa_ficha_id),
          recheio_principal_id: Number(m.recheio_id),
          recheio_secundario_id: Number(m.recheio_id),
          quantidade: 1,
          pedido: pedArr[i] || null,
        });
      }
    });

    try {
      let montagemId;

      if (editandoId) {
        // Modo edição: substitui todos os itens pelo estado atual do formulário
        await api.put(`/guia/montagens/${editandoId}`, {
          observacoes: observacoes || null,
          itens: novosItens,
        });
        montagemId = editandoId;
        setEditandoId(null);
      } else {
        // Modo criação: verifica se já existe montagem para a data e mescla
        const resList = await api.get('/guia/montagens');
        const existente = (resList.data || []).find(m => m.data === data);

        if (existente) {
          const resExistente = await api.get(`/guia/montagens/${existente.id}`);
          const itensExistentes = (resExistente.data.itens || []).map(i => ({
            tamanho_id: i.tamanho_id,
            massa_ficha_id: i.massa_ficha_id,
            recheio_principal_id: i.recheio_principal_id,
            recheio_secundario_id: i.recheio_secundario_id,
            quantidade: i.quantidade,
          }));
          await api.put(`/guia/montagens/${existente.id}`, {
            observacoes: observacoes || existente.observacoes || null,
            itens: [...itensExistentes, ...novosItens],
          });
          montagemId = existente.id;
        } else {
          const res = await api.post('/guia/montagens', {
            data,
            observacoes: observacoes || null,
            itens: novosItens,
          });
          montagemId = res.data.id;
        }
      }

      const resCalc = await api.get(`/guia/montagens/${montagemId}/calcular`);
      setResultado({ ...resCalc.data, congelados: coberturaCongelados, congeladosRetirar, observacoes, data });
      const savedMontados = localStorage.getItem(`montados_${montagemId}`);
      setMontados(savedMontados ? JSON.parse(savedMontados) : {});
      const savedRetirado = localStorage.getItem(`retirado_${montagemId}`);
      setRetiradoFreezer(savedRetirado ? JSON.parse(savedRetirado) : false);
      setAbas('fichas');
    } catch (e) {
      setErro(e.response?.data?.erro || 'Erro ao salvar montagem');
    } finally { setSalvando(false); }
  }

  // ── Fichas unitárias ──────────────────────────────────────────────────────────
  function gerarFichasUnitarias() {
    if (!resultado?.fichas_individuais) return [];
    const fichas = [];
    resultado.fichas_individuais.forEach(ficha => {
      for (let i = 0; i < ficha.quantidade; i++) {
        fichas.push({ ...ficha, _uid: `${ficha.tamanho}_${fichas.length}` });
      }
    });
    return fichas;
  }

  function toggleMontado(uid) { setMontados(prev => ({ ...prev, [uid]: !prev[uid] })); }

  const fichasUnitarias = resultado ? gerarFichasUnitarias() : [];
  const nMontados = Object.values(montados).filter(Boolean).length;

  function imprimirFicha(ficha, idx, cakeboard) {
    const dataFormatada = formatarData(resultado?.data || data);
    const massaNome = ficha.massa || '—';
    const pedidoStr = ficha.pedido ? `Pedido #${ficha.pedido}` : null;
    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    @page { size: 80mm auto; margin: 4mm 2mm; }
    * { margin: 0; padding: 0; box-sizing: border-box; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
    body { font-family: 'Courier New', monospace; font-size: 13px; font-weight: bold; color: #000; width: 68mm; }
    .header { text-align: center; border-bottom: 2px dashed #000; padding-bottom: 5px; margin-bottom: 7px; }
    .header h1 { font-size: 16px; font-weight: bold; }
    .header p { font-size: 13px; font-weight: bold; }
    .badge { font-size: 13px; background: #000 !important; color: #fff !important; display: inline-block; padding: 1px 6px; border-radius: 3px; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
    .section { margin-bottom: 6px; }
    .section-title { font-size: 12px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; border-bottom: 1px solid #000; margin-bottom: 4px; padding-bottom: 2px; }
    .row { display: flex; justify-content: space-between; font-size: 12px; font-weight: bold; margin-bottom: 2px; }
    .grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 4px; margin-bottom: 6px; }
    .cell { border: 1px solid #000; padding: 4px 5px; }
    .cell-label { font-size: 11px; font-weight: bold; text-transform: uppercase; }
    .cell-value { font-size: 14px; font-weight: bold; }
    .cell-total { font-size: 13px; font-weight: bold; }
    .recheio { border-top: 1px dashed #000; padding-top: 4px; margin-top: 4px; }
    .recheio:first-child { border-top: none; margin-top: 0; }
    .footer { text-align: center; font-size: 12px; font-weight: bold; border-top: 2px dashed #000; margin-top: 7px; padding-top: 4px; }
  </style>
</head>
<body>
  <div class="header">
    <h1>Demiplié Doces</h1>
    <p>${dataFormatada} &nbsp;·&nbsp; Ficha <span class="badge">${idx + 1}</span></p>
  </div>

  <div class="section">
    <div class="row">
      <span style="font-size:17px;font-weight:bold">${ficha.tamanho}</span>
      <span>CB: ${cakeboard}</span>
    </div>
    <div class="row"><span>Massa: ${massaNome}</span>${pedidoStr ? `<span>${pedidoStr}</span>` : ''}</div>
  </div>

  <div class="grid2">
    <div class="cell">
      <div class="cell-label">Discos</div>
      <div class="cell-value">${ficha.discos.camadas}x ${ficha.discos.gramas_por_camada}g</div>
      <div class="cell-total">= ${ficha.discos.total}g</div>
    </div>
    <div class="cell">
      <div class="cell-label">Calda</div>
      <div class="cell-value">${ficha.calda.camadas}x ${ficha.calda.gramas_por_camada}g</div>
      <div class="cell-total">= ${ficha.calda.total}g</div>
    </div>
    <div class="cell">
      <div class="cell-label">Cinta</div>
      <div class="cell-value">${ficha.cinta.camadas}x ${ficha.cinta.gramas_por_camada}g</div>
      <div class="cell-total">= ${ficha.cinta.total}g</div>
    </div>
    <div class="cell">
      <div class="cell-label">Cobertura</div>
      <div class="cell-value">${ficha.cobertura.camadas}x ${ficha.cobertura.gramas_por_camada}g</div>
      <div class="cell-total">= ${ficha.cobertura.total}g</div>
    </div>
  </div>

  <div class="section">
    <div class="section-title">Recheios</div>
    ${ficha.recheios.map(r => `
      <div class="recheio">
        <div class="row"><span>${r.recheio_nome}</span><span>${r.n_camadas} cam.</span></div>
        <div class="row"><span>${r.base.nome}</span><span>${r.n_camadas}x ${r.base.gramas_por_camada}g = ${r.base.gramas_total}g</span></div>
        ${r.complemento ? `<div class="row"><span>+ ${r.complemento.nome}</span><span>${r.n_camadas}x ${r.complemento.gramas_por_camada}g = ${r.complemento.gramas_total}g</span></div>` : ''}
      </div>
    `).join('')}
  </div>

  <div class="footer">Demipl&iacute;e &middot; ${dataFormatada}</div>
</body>
</html>`;

    const w = window.open('', '_blank', 'width=340,height=600');
    w.document.write(html);
    w.document.close();
    w.focus();
    setTimeout(() => { w.print(); w.close(); }, 300);
  }

  // ── Render ficha unitária ────────────────────────────────────────────────────
  function renderFichaUnitaria(ficha, idx) {
    const uid = ficha._uid;
    const feito = !!montados[uid];
    const t = tamanhos.find(t => t.nome === ficha.tamanho);
    const cakeboard = t?.cakeboard_tamanho || '—';

    return (
      <div key={uid} className="relative bg-white rounded-xl border-2 shadow-sm overflow-hidden transition-all duration-200"
        style={{ borderColor: feito ? '#86efac' : '#f3f4f6' }}>
        {feito && (
          <div className="absolute inset-0 bg-green-50 bg-opacity-85 z-10 flex flex-col items-center justify-center rounded-xl">
            <div className="text-4xl mb-1">✅</div>
            <p className="font-bold text-green-700 text-sm">Montado!</p>
            <button onClick={() => toggleMontado(uid)} className="mt-2 text-xs text-green-600 underline hover:text-green-800">Desmarcar</button>
          </div>
        )}
        <div className="flex items-center justify-between bg-pink-50 px-4 py-2.5 border-b border-pink-100">
          <div className="flex items-center gap-2">
            <span className="text-xs bg-pink-200 text-pink-700 font-bold rounded-full w-6 h-6 flex items-center justify-center">{idx + 1}</span>
            <div>
              <span className="font-bold text-pink-800 text-sm">{ficha.tamanho}</span>
              <span className="text-xs text-pink-400 ml-2">· CB: {cakeboard}</span>
              {ficha.massa && <p className="text-xs text-pink-500 font-medium leading-tight">{ficha.massa}{ficha.pedido && <span className="text-pink-400 font-normal"> · Pedido #{ficha.pedido}</span>}</p>}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={() => imprimirFicha(ficha, idx, cakeboard)}
              title="Imprimir ficha"
              className="text-gray-400 hover:text-pink-600 border border-gray-200 hover:border-pink-300 rounded-full p-1.5 transition-colors bg-white">
              <IconPrint />
            </button>
            <button onClick={() => toggleMontado(uid)}
              className={`flex items-center gap-1.5 text-xs px-3 py-1 rounded-full font-semibold border transition-colors ${
                feito ? 'bg-green-100 text-green-700 border-green-300' : 'bg-white text-gray-500 border-gray-200 hover:border-green-300 hover:text-green-600'
              }`}>
              <IconCheckbox checked={feito} />
              Montado
            </button>
          </div>
        </div>
        <div className="p-4 space-y-3 text-sm">
          <div className="grid grid-cols-2 gap-2">
            {[
              { label: 'Discos', dados: ficha.discos, cor: 'amber' },
              { label: 'Calda', dados: ficha.calda, cor: 'sky' },
              { label: 'Cinta', dados: ficha.cinta, cor: 'violet' },
              { label: 'Cobertura', dados: ficha.cobertura, cor: 'rose' },
            ].map(({ label, dados, cor }) => (
              <div key={label} className={`bg-${cor}-50 rounded-lg px-3 py-2`}>
                <p className={`text-xs font-semibold text-${cor}-600 mb-0.5`}>{label}</p>
                <p className="text-gray-700 text-xs">
                  {dados.camadas}× {dados.gramas_por_camada}g
                  <span className="text-gray-400 ml-1">= <strong>{dados.total}g</strong></span>
                </p>
              </div>
            ))}
          </div>
          <div className="border-t border-gray-100 pt-2">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">Recheios</p>
            <div className="space-y-1.5">
              {ficha.recheios.map((r, ri) => (
                <div key={ri} className="bg-gray-50 rounded-lg px-3 py-2">
                  <div className="flex justify-between mb-0.5">
                    <span className="font-semibold text-gray-700 text-xs">{r.recheio_nome}</span>
                    <span className="text-xs text-gray-400">{r.n_camadas} cam.</span>
                  </div>
                  <div className="text-xs text-gray-600 space-y-0.5">
                    <div className="flex justify-between">
                      <span className="text-gray-500">{r.base.nome}</span>
                      <span>{r.n_camadas}× {r.base.gramas_por_camada}g = <strong>{r.base.gramas_total}g</strong></span>
                    </div>
                    {r.complemento && (
                      <div className="flex justify-between text-gray-400">
                        <span>↳ {r.complemento.nome}</span>
                        <span>{r.n_camadas}× {r.complemento.gramas_por_camada}g = <strong>{r.complemento.gramas_total}g</strong></span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ── Ficha congelados (card único azul) ────────────────────────────────────────
  function renderFichaCongelados() {
    const lista = resultado?.congelados_montagem || [];
    if (!lista.length) return null;
    return (
      <div className={`relative col-span-1 md:col-span-2 rounded-xl border-2 shadow-sm overflow-hidden transition-all duration-200 ${
        retiradoFreezer ? 'border-green-300' : 'border-blue-200'
      }`}>
        {retiradoFreezer && (
          <div className="absolute inset-0 bg-green-50 bg-opacity-85 z-10 flex flex-col items-center justify-center rounded-xl">
            <div className="text-4xl mb-1">✅</div>
            <p className="font-bold text-green-700 text-sm">Retirado do freezer!</p>
            <button onClick={() => setRetiradoFreezer(false)} className="mt-2 text-xs text-green-600 underline hover:text-green-800">Desmarcar</button>
          </div>
        )}
        <div className="flex items-center justify-between bg-blue-50 px-4 py-2.5 border-b border-blue-100">
          <span className="font-bold text-blue-800 text-sm">❄️ Bolos Congelados — Retirar do Freezer</span>
          <button onClick={() => setRetiradoFreezer(true)}
            className={`flex items-center gap-1.5 text-xs px-3 py-1 rounded-full font-semibold border transition-colors ${
              retiradoFreezer ? 'bg-green-100 text-green-700 border-green-300' : 'bg-white text-blue-500 border-blue-200 hover:border-green-300 hover:text-green-600'
            }`}>
            <IconCheckbox checked={retiradoFreezer} />
            Retirado
          </button>
        </div>
        <div className="p-4">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs text-gray-400 uppercase">
                <th className="text-left pb-2">Item</th>
                <th className="text-left pb-2">Massa</th>
                <th className="text-center pb-2">Qtd</th>
                <th className="text-right pb-2">Cobertura</th>
                <th className="text-center pb-2">Cakeboard</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {lista.map((r, i) => (
                <tr key={i}>
                  <td className="py-1.5 font-medium text-gray-700">{r.tamanho} <span className="text-gray-400 font-normal text-xs">· {r.recheio}{r.pedido && <span className="text-blue-400"> · #{r.pedido}</span>}</span></td>
                  <td className="py-1.5 text-xs text-gray-500">{r.massa || '—'}</td>
                  <td className="py-1.5 text-center font-bold text-blue-700">{r.quantidade}</td>
                  <td className="py-1.5 text-right text-gray-600">{r.cobertura_total.toLocaleString('pt-BR')}g</td>
                  <td className="py-1.5 text-center text-gray-500">{r.cakeboard}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // ── Consolidado ───────────────────────────────────────────────────────────────
  function renderConsolidado() {
    const c = resultado.consolidado;
    const tabelaImediatos = calcularTabelaImediatos();

    const coberturaImediatos = tabelaImediatos.reduce((s, r) => s + r.cobertura * r.quantidade, 0);
    const coberturaCongelados = (resultado.congelados_montagem || []).reduce((s, r) => s + r.cobertura_total, 0);
    const coberturaTotal = coberturaImediatos + coberturaCongelados;

    return (
      <div className="space-y-4">
        {/* Congelados */}
        {resultado.congelados_montagem?.length > 0 && (
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-5">
            <h3 className="text-xs font-semibold text-blue-500 uppercase tracking-wider mb-3">❄️ Congelados — Retirar do Freezer</h3>
            <table className="w-full text-sm">
              <thead>
                <tr className="text-xs text-blue-400 uppercase">
                  <th className="text-left pb-2">Item</th>
                  <th className="text-center pb-2">Qtd</th>
                  <th className="text-right pb-2">Cobertura</th>
                  <th className="text-center pb-2">Cakeboard</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-blue-100">
                {resultado.congelados_montagem.map((r, i) => (
                  <tr key={i}>
                    <td className="py-2 font-medium text-blue-800">{r.tamanho}<span className="text-blue-500 font-normal ml-1 text-xs">· {r.recheio}{r.massa && <span className="text-blue-400"> ({r.massa})</span>}{r.pedido && <span className="text-blue-400"> · #{r.pedido}</span>}</span></td>
                    <td className="py-2 text-center text-blue-700 font-bold">{r.quantidade}</td>
                    <td className="py-2 text-right font-bold text-blue-800">{r.cobertura_total.toLocaleString('pt-BR')}g</td>
                    <td className="py-2 text-center text-blue-600">{r.cakeboard}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="border-t-2 border-blue-200">
                <tr>
                  <td colSpan={2} className="pt-2 text-right text-xs font-bold text-blue-500 uppercase">Total cobertura</td>
                  <td className="pt-2 text-right font-bold text-blue-800">
                    {resultado.congelados_montagem.reduce((s, r) => s + r.cobertura_total, 0).toLocaleString('pt-BR')}g
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        {/* Imediatos — tabela única */}
        {tabelaImediatos.length > 0 && (
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-5 py-3 bg-orange-50 border-b border-orange-100">
              <h3 className="text-xs font-semibold text-orange-500 uppercase tracking-wider">🕐 Imediatos — Buttercream & Calda</h3>
            </div>
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr>
                  <th className="text-left px-4 py-2.5 font-semibold text-gray-500 text-xs">Tamanho</th>
                  <th className="text-left px-3 py-2.5 font-semibold text-gray-500 text-xs">Massa</th>
                  <th className="text-center px-3 py-2.5 font-semibold text-gray-500 text-xs">Qtd</th>
                  <th className="text-center px-3 py-2.5 font-semibold text-gray-500 text-xs">Cakeboard</th>
                  <th className="text-right px-3 py-2.5 font-semibold text-sky-500 text-xs">Calda</th>
                  <th className="text-right px-3 py-2.5 font-semibold text-violet-500 text-xs">Cinta</th>
                  <th className="text-right px-4 py-2.5 font-semibold text-rose-500 text-xs">Cobertura</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {tabelaImediatos.map((r, i) => (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-4 py-2.5 font-medium text-gray-800">{r.tamanho}</td>
                    <td className="px-3 py-2.5 text-gray-600 text-xs">{r.massa}</td>
                    <td className="px-3 py-2.5 text-center text-gray-600">{r.quantidade}</td>
                    <td className="px-3 py-2.5 text-center text-gray-500">{r.cakeboard}</td>
                    <td className="px-3 py-2.5 text-right text-sky-700">{(r.calda * r.quantidade).toLocaleString('pt-BR')}g</td>
                    <td className="px-3 py-2.5 text-right text-violet-700">{(r.cinta * r.quantidade).toLocaleString('pt-BR')}g</td>
                    <td className="px-4 py-2.5 text-right text-rose-700 font-semibold">{(r.cobertura * r.quantidade).toLocaleString('pt-BR')}g</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="border-t-2 border-gray-200 bg-gray-50">
                <tr>
                  <td colSpan={4} className="px-4 py-2.5 text-xs font-bold text-gray-500 uppercase text-right">TOTAL</td>
                  <td className="px-3 py-2.5 text-right font-bold text-sky-700">
                    {tabelaImediatos.reduce((s, r) => s + r.calda * r.quantidade, 0).toLocaleString('pt-BR')}g
                  </td>
                  <td className="px-3 py-2.5 text-right font-bold text-violet-700">
                    {tabelaImediatos.reduce((s, r) => s + r.cinta * r.quantidade, 0).toLocaleString('pt-BR')}g
                  </td>
                  <td className="px-4 py-2.5 text-right font-bold text-rose-700">
                    {tabelaImediatos.reduce((s, r) => s + r.cobertura * r.quantidade, 0).toLocaleString('pt-BR')}g
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        {/* Total Buttercream (cobertura) */}
        {coberturaTotal > 0 && (
          <div className="bg-rose-50 border border-rose-100 rounded-xl px-5 py-3 flex items-center justify-between">
            <span className="text-sm font-semibold text-rose-700">🧴 Total Buttercream (cobertura)</span>
            <div className="flex items-center gap-4 text-sm">
              {coberturaImediatos > 0 && <span className="text-rose-400">Imediatos: {coberturaImediatos.toLocaleString('pt-BR')}g</span>}
              {coberturaCongelados > 0 && <span className="text-rose-400">Congelados: {coberturaCongelados.toLocaleString('pt-BR')}g</span>}
              <span className="font-bold text-rose-700 text-base">{coberturaTotal.toLocaleString('pt-BR')}g</span>
            </div>
          </div>
        )}

        {/* Recheios */}
        {c.recheios?.length > 0 && (
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Recheios — Preparar</h3>
            </div>
            <table className="w-full text-sm">
              <thead className="border-b border-gray-50">
                <tr>
                  <th className="text-left px-5 py-2.5 font-medium text-gray-500">Componente</th>
                  <th className="text-right px-4 py-2.5 font-medium text-gray-500">Total</th>
                  <th className="text-right px-5 py-2.5 font-medium text-gray-500">Receitas</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {c.recheios.map((r, i) => {
                  const recheioInfoBase = recheios.find(x => x.base_nome === r.nome);
                  const recheioInfoComp = recheios.find(x => x.complemento_nome === r.nome);
                  const temFicha = recheioInfoBase?.base_ficha_id || recheioInfoComp?.complemento_ficha_id;

                  // Calcula gramas por origem localmente
                  function gramasOrigem(origemStr) {
                    // Formato: "1× 13cm | 10 fatias (Brigadeiro)"
                    const match = origemStr.match(/^(\d+)×\s+(.+?)\s+\((.+)\)$/);
                    if (!match) return null;
                    const [, qtdStr, tamanhoNome, recheioNome] = match;
                    const qtd = Number(qtdStr);
                    const tamanho = tamanhos.find(t => t.nome === tamanhoNome);
                    if (!tamanho) return null;
                    const rp = (tamanho.recheios_permitidos || []).find(rp => rp.recheio_nome === recheioNome);
                    if (!rp) return null;
                    // Descobre se r.nome é base ou complemento desse recheio
                    const recheioInfo = recheios.find(x => x.nome === recheioNome);
                    const isBase = recheioInfo?.base_nome === r.nome;
                    const gramasPorBolo = isBase ? (rp.gramas_base || 0) : (rp.gramas_complemento || 0);
                    return qtd * gramasPorBolo;
                  }

                  return (
                  <tr key={i} className="hover:bg-gray-50">
                    <td className="px-5 py-3">
                      <p className="font-medium text-gray-800">{r.nome}</p>
                      {r.origens?.length > 0 && (
                        <div className="text-xs text-gray-400 mt-0.5 space-y-0.5">
                          {r.origens.map((o, oi) => {
                            const g = gramasOrigem(o);
                            return (
                              <p key={oi}>{o}{g != null ? ` — ${g}g` : ''}</p>
                            );
                          })}
                        </div>
                      )}
                    </td>
                    <td className="px-4 py-3 text-right font-semibold text-gray-700">{r.total_gramas}g</td>
                    <td className="px-5 py-3 text-right">
                      <div className="flex items-center justify-end gap-2">
                        {r.receitas != null
                          ? <span className="inline-block whitespace-nowrap bg-pink-100 text-pink-700 px-2.5 py-0.5 rounded-full font-semibold text-sm">{r.receitas} receita{r.receitas !== 1 ? 's' : ''}</span>
                          : <span className="text-xs text-gray-400">pesar direto</span>}
                        {temFicha && r.receitas != null && (
                          <button onClick={() => abrirModalReceita(r.nome, r.receitas)}
                            disabled={modalLoading === r.nome}
                            className="text-xs border border-pink-200 text-pink-600 hover:bg-pink-50 rounded-md px-2 py-0.5 font-medium transition-colors disabled:opacity-60 flex items-center gap-1">
                            {modalLoading === r.nome
                              ? <><span className="inline-block w-3 h-3 border-2 border-pink-400 border-t-transparent rounded-full animate-spin"></span> carregando</>
                              : <>📋 ver</>}
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }

  if (loading) return <div className="text-center py-12 text-gray-400">Carregando...</div>;

  return (
    <div className="p-6 max-w-5xl mx-auto">

      {/* Modal Receita */}
      {modalReceita && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={e => e.target === e.currentTarget && setModalReceita(null)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-4 max-h-[88vh] overflow-y-auto">
            <div className="flex items-start justify-between px-6 py-4 border-b border-gray-100">
              <div>
                <h2 className="text-lg font-bold text-gray-800">{modalReceita.nome}</h2>
                <p className="text-sm text-gray-400">
                  {modalReceita.nReceitas} receita{modalReceita.nReceitas !== 1 ? 's' : ''}
                  {modalReceita.ficha?.peso_total ? ` · ${(modalReceita.ficha.peso_total * modalReceita.nReceitas).toLocaleString('pt-BR')}g total` : ''}
                </p>
              </div>
              <button onClick={() => setModalReceita(null)} className="text-gray-400 hover:text-gray-600 text-2xl font-bold leading-none ml-4">×</button>
            </div>
            <div className="px-6 py-5">
              {(() => {
                const insumos = (modalReceita.ficha?.itens || []).filter(i => i.tipo === 'insumo');
                const n = modalReceita.nReceitas;
                const cols = Array.from({length: Math.max(n, 1)}, (_, i) => i + 1);
                if (!insumos.length) return <p className="text-sm text-gray-400">Sem ingredientes cadastrados.</p>;
                return (
                  <table className="w-full text-sm border-collapse">
                    <thead>
                      <tr className="bg-pink-50">
                        <th className="text-left px-3 py-2 font-semibold text-gray-600">Ingrediente</th>
                        <th className="text-center px-3 py-2 font-semibold text-gray-500">Un.</th>
                        {cols.map(c => <th key={c} className="text-center px-3 py-2 font-semibold text-gray-600">{c}x</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {insumos.map((item, i) => (
                        <tr key={i} className="border-t border-gray-50 hover:bg-gray-50">
                          <td className="px-3 py-2 font-medium text-gray-800">{item.nome}</td>
                          <td className="px-3 py-2 text-center text-gray-400">{item.unidade_medida}</td>
                          {cols.map(c => {
                            const v = item.quantidade * c;
                            return <td key={c} className="px-3 py-2 text-center text-gray-700">{v % 1 === 0 ? v : v.toFixed(2).replace('.', ',')}</td>;
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                );
              })()}
              {modalReceita.ficha?.modo_preparo && (
                <details className="mt-4">
                  <summary className="cursor-pointer text-sm font-semibold text-amber-700">👨‍🍳 Modo de preparo</summary>
                  <div className="mt-2 text-sm text-gray-600 whitespace-pre-wrap leading-relaxed bg-amber-50 rounded-lg p-3 border-l-4 border-amber-200">{modalReceita.ficha.modo_preparo}</div>
                </details>
              )}
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Montagem Diária</h1>
          <p className="text-gray-500 text-sm mt-1">Gere fichas de montagem com quantidades exatas para cada bolo</p>
        </div>
        <button onClick={() => { setHistoricoAberto(true); carregarHistorico(); }}
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" title="Histórico">
          <IconHistory />
        </button>
      </div>

      {erro && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">{erro}</div>}

      {/* ── Formulário ── */}
      {!resultado && (
        <form onSubmit={salvarECalcular} className="space-y-4">

          {/* Data + Obs */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
            <div className="flex gap-4">
              <div className="shrink-0">
                <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">Data</label>
                <input type="date" value={data} onChange={e => setData(e.target.value)} required
                  className="border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-200 bg-gray-50" />
              </div>
              <div className="flex-1">
                <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">Observações</label>
                <input type="text" value={observacoes} onChange={e => setObservacoes(e.target.value)}
                  placeholder="pedidos urgentes, evento especial..."
                  className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pink-200 bg-gray-50" />
              </div>
            </div>
          </div>

          {/* Imediatos */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <div className="px-5 py-3.5 border-b border-gray-50 flex items-center justify-between">
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-xl bg-pink-50 flex items-center justify-center text-base">🕐</div>
                <div>
                  <span className="font-semibold text-gray-800 text-base">Bolos Imediatos</span>
                  {itens.length > 0 && (
                    <span className="ml-2 text-xs bg-pink-50 text-pink-500 font-semibold px-2 py-0.5 rounded-full">
                      {itens.reduce((a, i) => a + Number(i.quantidade), 0)} bolos
                    </span>
                  )}
                </div>
              </div>
              <button type="button" onClick={adicionarItem}
                className="flex items-center gap-1 text-xs font-semibold text-pink-500 hover:text-pink-700 bg-pink-50 hover:bg-pink-100 px-3 py-1.5 rounded-xl transition-colors">
                + Adicionar
              </button>
            </div>

            {itens.length === 0 ? (
              <div className="py-10 flex flex-col items-center gap-3 text-gray-300">
                <span className="text-4xl">🎂</span>
                <p className="text-sm text-gray-400">Nenhum bolo adicionado</p>
                <button type="button" onClick={adicionarItem}
                  className="text-xs font-semibold text-pink-500 bg-pink-50 hover:bg-pink-100 px-4 py-2 rounded-xl transition-colors">
                  + Adicionar primeiro bolo
                </button>
              </div>
            ) : (
              <div className="divide-y divide-gray-50">
                {itens.map((item, idx) => (
                  <div key={item.id} className="px-5 py-4 hover:bg-gray-50/50 transition-colors">
                    <div className="flex items-start gap-3">
                      {/* Badge número */}
                      <div className="w-6 h-6 rounded-full bg-pink-100 text-pink-600 text-xs font-bold flex items-center justify-center mt-0.5 shrink-0">{idx + 1}</div>

                      <div className="flex-1 space-y-2.5">
                        {/* Linha 1: Tamanho + Massa */}
                        <div className="grid grid-cols-2 gap-2">
                          <div>
                            <label className="block text-xs text-gray-400 font-medium mb-1">Tamanho</label>
                            <select value={item.tamanho_id} onChange={e => atualizarItem(item.id, 'tamanho_id', e.target.value)}
                              className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-200 focus:bg-white transition-colors">
                              <option value="">— selecione —</option>
                              {tamanhos.map(t => <option key={t.id} value={t.id}>{t.nome} ({t.fatias}f)</option>)}
                            </select>
                          </div>
                          <div>
                            <label className="block text-xs text-gray-400 font-medium mb-1">Massa</label>
                            {(() => {
                              const t = tamanhos.find(t => String(t.id) === String(item.tamanho_id));
                              const massasDoTamanho = t?.massas_permitidas?.length
                                ? fichasMassa.filter(f => t.massas_permitidas.some(m => m.ficha_tecnica_id === f.id))
                                : fichasMassa;
                              return (
                                <select value={item.massa_ficha_id} onChange={e => atualizarItem(item.id, 'massa_ficha_id', e.target.value)}
                                  className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-200 focus:bg-white transition-colors">
                                  <option value="">— selecione —</option>
                                  {massasDoTamanho.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                                </select>
                              );
                            })()}
                          </div>
                        </div>

                        {/* Linha 2: Recheios */}
                        <div>
                          <div className="flex items-center gap-3 mb-1.5">
                            <label className="text-xs text-gray-400 font-medium">Recheio</label>
                            <label className="flex items-center gap-1.5 text-xs text-gray-500 cursor-pointer select-none">
                              <input type="checkbox" checked={item.recheio_unico}
                                onChange={e => atualizarItem(item.id, 'recheio_unico', e.target.checked)}
                                className="accent-pink-500 rounded" />
                              <span>Recheio único</span>
                            </label>
                          </div>
                          {item.recheio_unico ? (
                            <select value={item.recheio_principal_id} onChange={e => atualizarItem(item.id, 'recheio_principal_id', e.target.value)}
                              className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-200 focus:bg-white transition-colors">
                              <option value="">— selecione —</option>
                              {recheios.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
                            </select>
                          ) : (
                            <div className="grid grid-cols-2 gap-2">
                              {[['recheio_principal_id', 'Principal'], ['recheio_secundario_id', 'Secundário']].map(([campo, label]) => (
                                <div key={campo}>
                                  <label className="block text-xs text-gray-400 mb-1">{label}</label>
                                  <select value={item[campo]} onChange={e => atualizarItem(item.id, campo, e.target.value)}
                                    className="w-full border border-gray-200 rounded-xl px-3 py-2 text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-200 focus:bg-white transition-colors">
                                    <option value="">— selecione —</option>
                                    {recheios.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
                                  </select>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* Linha 3: Pedido */}
                        <div className="flex items-center gap-2">
                          <label className="text-xs text-gray-400 font-medium whitespace-nowrap">Pedido #</label>
                          <input type="text" value={item.pedido || ''} onChange={e => atualizarItem(item.id, 'pedido', e.target.value)}
                            placeholder="opcional"
                            className="w-32 border border-gray-200 rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-pink-200 bg-gray-50" />
                        </div>
                      </div>

                      <button type="button" onClick={() => removerItem(item.id)}
                        className="text-gray-200 hover:text-red-400 mt-0.5 shrink-0 transition-colors text-lg leading-none">✕</button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {itens.length > 0 && (
              <div className="px-5 py-3 border-t border-gray-100">
                <button type="button" onClick={adicionarItem}
                  className="flex items-center gap-1 text-xs font-semibold text-pink-500 hover:text-pink-700 bg-pink-50 hover:bg-pink-100 px-3 py-1.5 rounded-xl transition-colors">
                  + Adicionar
                </button>
              </div>
            )}
          </div>

          {/* Congelados */}
          {tamanhosCongelados.length > 0 && menuFixo.length > 0 && (
            <div className="rounded-2xl border border-blue-100 shadow-sm overflow-hidden">
              <div className="bg-gradient-to-r from-blue-50 to-sky-50 px-5 py-3.5 border-b border-blue-100 flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-xl bg-blue-100 flex items-center justify-center text-base">❄️</div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-blue-900 text-base">Bolos Congelados</span>
                    {totalCongelados > 0 && (
                      <span className="text-xs bg-blue-100 text-blue-600 font-semibold px-2 py-0.5 rounded-full">
                        {totalCongelados} bolos
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-blue-400 mt-0.5">Já produzidos — calcula cobertura e cakeboards</p>
                </div>
              </div>
              <div className="bg-white divide-y divide-gray-50">
                {tamanhosCongelados.map(t => {
                  const itensDoTamanho = menuFixo.filter(m => m.tamanho_id === t.id);
                  if (!itensDoTamanho.length) return null;
                  return (
                    <div key={t.id}>
                      <div className="px-5 py-2 bg-gray-50/70 flex items-center gap-2">
                        <span className="font-semibold text-gray-700 text-xs uppercase tracking-wider">{t.nome}</span>
                        <span className="text-xs text-gray-400">· {t.fatias} fatias</span>
                      </div>
                      <div className="px-5 py-3 space-y-2.5">
                        {itensDoTamanho.map(m => (
                          <div key={m.id} className="space-y-1.5">
                            <div className="flex items-center justify-between gap-4">
                              <div className="flex-1 min-w-0">
                                <span className="text-sm text-gray-700 font-medium truncate block">{m.recheio_nome}</span>
                                <span className="text-xs text-gray-400">{m.massa_ficha_nome}</span>
                              </div>
                              <div className="flex items-center gap-1.5 shrink-0">
                                <button type="button" onClick={() => setQtdCongelado(m.id, getQtdCongelado(m.id) - 1)}
                                  className="w-7 h-7 rounded-lg border border-gray-200 text-gray-400 hover:border-blue-300 hover:text-blue-500 flex items-center justify-center font-bold transition-colors">−</button>
                                <input type="number" min="0" value={getQtdCongelado(m.id) || ''} onChange={e => setQtdCongelado(m.id, e.target.value)}
                                  placeholder="0"
                                  className="w-14 text-center border border-gray-200 rounded-lg px-2 py-1.5 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-blue-200 bg-gray-50" />
                                <button type="button" onClick={() => setQtdCongelado(m.id, getQtdCongelado(m.id) + 1)}
                                  className="w-7 h-7 rounded-lg border border-gray-200 text-gray-400 hover:border-blue-300 hover:text-blue-500 flex items-center justify-center font-bold transition-colors">+</button>
                              </div>
                            </div>
                            {getQtdCongelado(m.id) > 0 && (
                              <div className="flex items-center gap-1.5 pl-1 flex-wrap">
                                <span className="text-xs text-blue-400 font-medium whitespace-nowrap">Pedido #</span>
                                {Array.from({ length: getQtdCongelado(m.id) }).map((_, i) => (
                                  <input key={i} type="text"
                                    value={(pedidosCongelados[m.id] || [])[i] || ''}
                                    onChange={e => setPedidosCongelados(prev => {
                                      const arr = [...(prev[m.id] || Array(getQtdCongelado(m.id)).fill(''))];
                                      arr[i] = e.target.value;
                                      return { ...prev, [m.id]: arr };
                                    })}
                                    placeholder={`${i + 1}`}
                                    className="w-20 border border-blue-100 rounded-lg px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-blue-200 bg-blue-50/50 text-blue-700" />
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          <div className="flex justify-end pt-1">
            <button type="submit" disabled={salvando || (itens.length === 0 && totalCongelados === 0)}
              className="bg-pink-500 hover:bg-pink-600 disabled:opacity-50 disabled:cursor-not-allowed text-white px-6 py-2.5 rounded-xl font-semibold text-sm shadow-sm hover:shadow-md transition-all">
              {salvando ? '⏳ Gerando fichas...' : '✦ Gerar Fichas de Montagem'}
            </button>
          </div>
        </form>
      )}

      {/* ── Resultado ── */}
      {resultado && (
        <div className="space-y-5">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-bold text-gray-800">
                Fichas de Montagem — {formatarData(resultado.data)}
              </h2>
              <p className="text-sm text-gray-400 mt-0.5">
                {(() => {
                  const nImediatos = fichasUnitarias.length;
                  const nCongelados = (resultado.congeladosRetirar || []).reduce((s, c) => s + (c.quantidade || 1), 0);
                  const total = nImediatos + nCongelados;
                  return (
                    <>
                      <span className="font-medium text-gray-600">{total} bolos no total</span>
                      {nImediatos > 0 && <span className="ml-2">· {nImediatos} imediato{nImediatos !== 1 ? 's' : ''}</span>}
                      {nCongelados > 0 && <span className="ml-2">· {nCongelados} congelado{nCongelados !== 1 ? 's' : ''}</span>}
                      {nImediatos > 0 && (
                        <span className="ml-2 text-green-600 font-medium">· {nMontados}/{nImediatos} montados</span>
                      )}
                    </>
                  );
                })()}
              </p>
              {resultado.observacoes && (
                <p className="text-sm text-gray-500 mt-1 italic">📝 {resultado.observacoes}</p>
              )}
            </div>
            <div className="flex gap-2">
              <button onClick={() => editarMontagem(resultado.montagem_id)}
                className="text-sm text-pink-600 hover:text-pink-800 border border-pink-200 hover:border-pink-400 px-3 py-1.5 rounded-lg transition-colors">
                ✏️ Editar
              </button>
              <button onClick={() => { setResultado(null); setItens([]); setItensCongelados({}); setPedidosCongelados({}); setMontados({}); setRetiradoFreezer(false); setObservacoes(''); setData((() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; })()); setEditandoId(null); }}
                className="text-sm text-gray-500 hover:text-gray-700 border border-gray-200 px-3 py-1.5 rounded-lg">
                ← Nova montagem
              </button>
            </div>
          </div>

          {fichasUnitarias.length > 0 && (
            <div className="w-full bg-gray-100 rounded-full h-2">
              <div className="bg-green-400 h-2 rounded-full transition-all duration-500"
                style={{ width: `${(nMontados / fichasUnitarias.length) * 100}%` }} />
            </div>
          )}

          <div className="flex gap-1 bg-gray-100 rounded-lg p-1 w-fit">
            {[
              { key: 'fichas', label: `Fichas (${fichasUnitarias.length})` },
              { key: 'consolidado', label: 'Consolidado' },
            ].map(aba => (
              <button key={aba.key} onClick={() => setAbas(aba.key)}
                className={`px-4 py-1.5 rounded-md text-sm font-medium transition-colors ${
                  abas === aba.key ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500 hover:text-gray-700'
                }`}>{aba.label}</button>
            ))}
          </div>

          {abas === 'fichas' ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {renderFichaCongelados()}
              {fichasUnitarias.map((ficha, idx) => renderFichaUnitaria(ficha, idx))}
            </div>
          ) : renderConsolidado()}
        </div>
      )}

      {/* ── Modal Histórico ── */}
      {historicoAberto && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
              <h2 className="text-lg font-bold text-gray-800">Histórico de Montagens</h2>
              <button onClick={() => setHistoricoAberto(false)} className="text-gray-400 hover:text-gray-600 text-xl font-bold">×</button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-4">
              {loadingHistorico ? (
                <p className="text-center text-gray-400 py-8">Carregando...</p>
              ) : historico.length === 0 ? (
                <p className="text-center text-gray-400 py-8 text-sm">Nenhuma montagem no histórico.</p>
              ) : (
                <div className="space-y-2">
                  {historico.map(h => (
                    <div key={h.id} className="flex items-center gap-2">
                      <button type="button" onClick={() => reabrirMontagem(h.id)}
                        className="flex-1 text-left bg-gray-50 hover:bg-pink-50 border border-gray-100 hover:border-pink-200 rounded-xl px-4 py-3 transition-colors">
                        <div className="flex items-center justify-between">
                          <span className="font-semibold text-gray-800 text-sm">
                            {new Date(h.data + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: 'short' })}
                          </span>
                          <span className="text-xs text-gray-400">{(h.itens || []).reduce((s, i) => s + (i.quantidade || 1), 0) || '—'} bolos</span>
                        </div>
                        {h.observacoes && <p className="text-xs text-gray-400 mt-0.5">{h.observacoes}</p>}
                      </button>
                      <button type="button" onClick={() => excluirMontagem(h.id)}
                        title="Excluir montagem"
                        className="shrink-0 text-gray-300 hover:text-red-500 hover:bg-red-50 border border-transparent hover:border-red-200 rounded-lg p-2 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}